'use strict';
const template = require('lodash/template');
const reduce = require('lodash/reduce');
const IMAGE_URI = 'image://';
const VERSION = 'v1';
const wixCodeImgUriTemplate = template(IMAGE_URI + VERSION + '/${uri}/${width}_${height}/${title}');
const MEDIA_SRC_REGEX = /^image:\/\/(.*)\/(.*)\/(.*)_(.*)\/(.*)/;

function generateWixCodeImageUri(imageData) {
  return wixCodeImgUriTemplate(imageData);
}

function removeEmptyValues(res, v, k) {
  if (v) {
    res[k] = v;
  }
  return res;
}

function extractImageRelativeUriFromWixUri(wixCodeImageUri) {
  if (MEDIA_SRC_REGEX.test(wixCodeImageUri)) {
    const [, , baseSrc] = wixCodeImageUri.match(MEDIA_SRC_REGEX) || [0, 0, wixCodeImageUri];
    return baseSrc;
  }

  return wixCodeImageUri;
}

function extractImageDataFromWixUri(wixCodeImageUri) {
  if (MEDIA_SRC_REGEX.test(wixCodeImageUri)) {
    const [, , uri, width, height, title] = wixCodeImageUri.match(MEDIA_SRC_REGEX) || [0, 0, wixCodeImageUri];
    return reduce({uri, width, height, title}, removeEmptyValues, {});
  }

  return {uri: wixCodeImageUri};
}

module.exports = {
  generateWixCodeImageUri,
  extractImageRelativeUriFromWixUri,
  extractImageDataFromWixUri
};




// WEBPACK FOOTER //
// ./src/uriUtils.js